import { api, money } from "@/pages/portal/api";

export { api, money };

export const INVESTOR_DISCLOSURE =
  "Confidential preliminary discussion materials. No offer to sell or solicitation to buy securities. " +
  "No funds are being accepted. Participation is subject to due diligence, definitive agreements, and legal approval.";

export const STATUS_STYLES = {
  new: "border-sky-500/40 bg-sky-400/10 text-sky-700",
  reviewing: "border-yellow-500/40 bg-yellow-400/10 text-yellow-700",
  approved: "border-emerald-500/40 bg-emerald-400/10 text-emerald-700",
  declined: "border-red-500/40 bg-red-400/10 text-red-600",
  open: "border-aqua/50 bg-aqua/10 text-aqua",
  waitlist: "border-yellow-500/40 bg-yellow-400/10 text-yellow-700",
  closed: "border-red-500/40 bg-red-400/10 text-red-600",
  active: "border-aqua/50 bg-aqua/10 text-aqua",
  withdrawn: "border-black/20 bg-black/5 text-muted",
  pending: "border-yellow-500/40 bg-yellow-400/10 text-yellow-700",
  pending_approval: "border-yellow-500/40 bg-yellow-400/10 text-yellow-700",
  published: "border-emerald-500/40 bg-emerald-400/10 text-emerald-700",
  paid: "border-emerald-500/40 bg-emerald-400/10 text-emerald-700",
  answered: "border-emerald-500/40 bg-emerald-400/10 text-emerald-700",
  requested: "border-sky-500/40 bg-sky-400/10 text-sky-700",
};

export const Badge = ({ value, testid }) => (
  <span
    data-testid={testid}
    className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-[11px] font-bold uppercase tracking-wider ${STATUS_STYLES[value] || "border-black/20 bg-black/5 text-muted"}`}
  >
    {String(value || "").replace(/_/g, " ")}
  </span>
);

export const GateBadge = ({ label, value, testid }) => (
  <span
    data-testid={testid}
    className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-[11px] font-bold uppercase tracking-wider ${
      value === "ON" || value === "TEST"
        ? "border-red-500/40 bg-red-500/10 text-red-700"
        : "border-emerald-500/40 bg-emerald-400/10 text-emerald-700"
    }`}
  >
    <span className={`h-1.5 w-1.5 rounded-full ${value === "ON" || value === "TEST" ? "bg-red-600" : "bg-emerald-500"}`} />
    {label}: {value}
  </span>
);

export const DisclosureBar = () => (
  <p className="rounded-lg border border-red-500/25 bg-red-500/[0.06] px-4 py-3 text-[11px] leading-relaxed text-red-800" data-testid="investor-disclosure">
    {INVESTOR_DISCLOSURE}
  </p>
);

export const downloadBlob = async (path) => {
  const { data, headers } = await api.get(path, { responseType: "blob" });
  const dispo = headers["content-disposition"] || "";
  const match = dispo.match(/filename="?([^";]+)"?/);
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  a.download = match ? match[1] : "document";
  a.click();
  URL.revokeObjectURL(url);
};
